import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { useParams, Navigate } from 'react-router-dom';
import Navbar from "../components/Navbar";
import MainSection from "../components/MainSection";
import ImageSection from "../components/ImageSection";
import OverviewSection from "../components/OverviewSection";
import DetailsSection from "../components/DetailsSection";
import Footer from "../components/Footer";
import MoreProjects from "../components/MoreProjects";
import { getProjectContent, projectExists } from "../config/portfolioConfig";

function SinglePortfolio(props) {
  const { work } = useParams();
  
  // Scroll to top when project changes
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [work]);

  // Check if project exists
  if (!projectExists(work)) {
    return <Navigate to="/404" replace />;
  }

  // Get project content
  const content = getProjectContent(work);

  return (
    <div>
      <div data-aos="fade-in" data-aos-duration="2000" data-aos-delay="500">
        <Navbar 
          switchMode={props.switchMode}
          lightMode={props.lightMode}
          activeLink="home" 
        />
      </div>

      {/* Main Section */}
      <MainSection content={content.mainTitle} />

      {/* Image Section */}
      <ImageSection content={content.image} />

      {/* Overview Section */}
      <OverviewSection content={content.overview} />

      {/* Details Section */}
      <DetailsSection content={content.details} />

      <MoreProjects selectedPortfolio={work} />

      <section>
        <div className="container hr-div">
          <hr />
        </div>
      </section>

      <section>
        <Footer />
      </section>

    </div>
  );
}

SinglePortfolio.propTypes = {
  switchMode: PropTypes.func.isRequired,
  lightMode: PropTypes.bool.isRequired
};

export default SinglePortfolio;
